export default __webpack_public_path__ + "static/media/conga-login.410a8dec.png";